<template>
  <div class="flex gap-2 mb-2 mt-1 flex-wrap pb-2 pt-2" :style="isSub ? 'padding-bottom: 0 !important; padding-top: 0 !important; margin-bottom: 0 !important; margin-top: 0 !important;' : ''">
    <ZapiPillButton 
      v-for="cat in categorias" 
      :key="cat"
      :label="cat"
      :active="modelValue === cat"
      :isSub="isSub"
      @click="$emit('update:modelValue', cat)"
    />
  </div>
</template>

<script>
import ZapiPillButton from '../atoms/ZapiPillButton.vue';

export default {
  name: 'ZapiCategoryTabs',
  components: { ZapiPillButton },
  props: {
    modelValue: { type: String, required: true },
    categorias: { type: Array, required: true },
    isSub: { type: Boolean, default: false }
  },
  emits: ['update:modelValue']
}
</script>